<div class="container-fluid">
  <div class="row">
    <div class="sidebar border border-right col-md-3 col-lg-2 p-0 bg-body-tertiary">
      <div class="d-flex flex-column flex-shrink-0 p-3 bg-body-tertiary" style="width: 280px;">
        <div href="/" class="d-flex align-items-center mb-3 mb-md-0 me-md-auto link-body-emphasis text-decoration-none pb-4">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left-circle" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
          </svg>
          <span class="fs-6">&nbsp; <a routerLink="/home">Back To Map</a> </span>
        </div>
        <ul class="nav nav-pills flex-column mb-auto">
          <li class="nav-item" role="presentation">
            <a href="#" class="nav-link active" id="details-tab" data-bs-toggle="tab" data-bs-target="#details" type="button" role="tab" aria-controls="details" aria-selected="true">
              <svg class="bi pe-none me-2" width="16" height="16" aria-hidden="true">
                <use xlink:href="#home"></use>
              </svg>
              Project Details
            </a>
          </li>
          <li class="nav-item" role="presentation">
            <a href="#" class="nav-link" id="camera-tab" data-bs-toggle="tab" data-bs-target="#camera" type="button" role="tab" aria-controls="camera" aria-selected="false">
              <svg class="bi pe-none me-2" width="16" height="16" aria-hidden="true">
                <use xlink:href="#table"></use>
              </svg>
              Project Camera
            </a>
          </li>
        </ul>
      </div>
    </div>
    <main class="col-md-9 ms-sm-auto col-lg-10 px-md-4">
      <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1 class="h2">{{ project.displayName }}</h1>
      </div>
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active" id="details" role="tabpanel" aria-labelledby="details-tab">
          <div class="row">
            <h2>Details</h2>
          </div>
          <div class="row g-5">
            <div class="col-md-6">
              <div class="">
                <table class="table table-sm">
                  <tbody>
                    <tr>
                      <td style="width: 100px;"><b>Location:</b></td>
                      <td colspan="3">{{ project.location.address}}, {{ project.location.city}}, {{ project.location.state}} {{ project.location.zip}}</td>
                    </tr>
                    <tr>
                      <td style="width: 100px;"><b>Client:</b></td>
                      <td>{{project.client}}</td>
                      <td><b>Contract Type:</b></td>
                      <td>{{project.contractType}}</td>
                    </tr>
                    <tr>
                      <td><b>Start Date:</b></td>
                      <td>{{project.startDate | date: 'MM/dd/yyyy'}}</td>
                      <td><b>End Date:</b></td>
                      <td>{{project.completionDate | date: 'MM/dd/yyyy'}}</td>
                    </tr>
                    <tr>
                      <td><b>Market:</b></td>
                      <td>{{project.market}}</td>
                      <td><b>Business Unit:</b></td>
                      <td>{{project.businessUnit}}</td>
                    </tr>
                    <tr>
                      <td><b>Manager:</b></td>
                      <td>{{project.manager}}</td>
                      <td><b>Fin. Coordinator:</b></td>
                      <td>{{project.financialCoordinator}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-md-6">
              <div id="myMap"></div>
            </div>
          </div>
          <div class="row mt-3">
            <h2>Personnel</h2>
          </div>
          <div class="row g-5">
            <div class="col-md-12">
              <div class="overflow-auto" style="height: 500px;">
                <table class="table table-striped table-sm">
                  <thead class="sticky-top bg-white">
                    <tr>
                      <th scope="col">Name</th>
                      <th scope="col">Title</th>
                      <th scope="col">Start Date</th>
                      <th scope="col">End Date</th>
                    </tr>
                  </thead>
                  <tbody>

                    <tr *ngFor="let person of project.personnel | sort:'endDate' : 'desc'">
                      <td>{{person.name}}</td>
                      <td>{{person.title}}</td>
                      <td>{{person.startDate | date: 'MM/dd/yyyy'}}</td>
                      <td>{{person.endDate | date: 'MM/dd/yyyy'}}</td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="camera" role="tabpanel" aria-labelledby="camera-tab">
          <div style="width:100%; position:relative; margin:0; padding:0; padding-bottom:56.25% !important;">
            <iframe [src]="iframeUrl" style="box-sizing:border-box; border:1px solid #444; position:absolute; top:0; left:0; width:100%; height:100%;"></iframe>
          </div>
        </div>
      </div>
    </main>
  </div>
</div>
